import { useState } from 'react';
import { Zoom, toast } from 'react-toastify';
import styled from 'styled-components';
import WarningIcon from '@paradigm/design-system/src/assets/WarningIcon';
import {
  alto,
  paradigmLightBlue,
  richBlack,
} from '@paradigm/design-system/src/colors';

export const BaseWarningToast = ({
  errorMessage,
  errorDetails,
  ...rest
}: {
  errorMessage: string;
  errorDetails?: string;
}) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <div {...rest}>
      <span>{errorMessage}</span>
      {errorDetails !== undefined && showDetails && (
        <ErrorDetails>
          <span>{errorDetails}</span>
        </ErrorDetails>
      )}
      {errorDetails !== undefined && (
        <div
          style={{ color: paradigmLightBlue, marginTop: 8 }}
          onClick={() => {
            setShowDetails(!showDetails);
          }}
          aria-hidden="true"
        >
          {!showDetails ? 'Show Details' : 'Hide Details'}
        </div>
      )}
    </div>
  );
};

export const toastWarning = (errorMessage: string, errorDetails?: string) => {
  toast.warn(
    <BaseWarningToast
      errorMessage={errorMessage}
      errorDetails={errorDetails}
    />,
    {
      icon: () => <WarningIcon />,
      position: 'top-center',
      hideProgressBar: true,
      autoClose: false,
      draggable: false,
      progress: undefined,
      transition: Zoom,
    },
  );
};

const ErrorDetails = styled.div`
  margin: 8px -8px;
  border-radius: 4px;
  padding: 8px;
  color: ${alto};
  background: ${richBlack};
  font-family: monospace;
  font-size: 12px;
`;
